import { Group, TextInput, Modal, Text, Center, Title, Button } from '@mantine/core';
import { IconBadgeVr, IconSearch, IconGridDots } from '@tabler/icons-react';
import React, { useMemo } from 'react';
import DataTable from 'react-data-table-component';
import UserRow from './components/UserRow';
import { useNavigate } from "react-router-dom";
import useGetUser from "./useUsers";
import LoadingErrorContainer from '../../../components/placeholders/LoadingErrorContainer';
import ActionCell from './components/ActionCell';
import useGetProfileDetails from '../settings/useGetProfile';

const Remote = () => {
    const navigate = useNavigate();
    const { themeQuery: {
        data, isPending, isError, isRefetching },
        totalRows,
        handleChangePerPage,
        handlePageChange,
        search,
        setSearch,
        queryKey
    } = useGetUser()

    const { data: profileData, isPending: profileIsPending, isError: profileIsError } = useGetProfileDetails();




    const columns = useMemo(() => {

        let temp = [
            {
                name: 'Tiktok Username',
                selector: row => row.tiktok_username ?? 'N/A',
                sortable: true,
                cell: row => <UserRow row={row} />,
                width: "200px",
            },

            {
                name: 'Email',
                selector: row => <Group>

                    {row.email ?? 'N/A'}

                    {((row.is_email_verified == true) ? <IconBadgeVr size={22} color='green' /> : "")}
                </Group>
                ,
                // width: "250px",

                sortable: true,
            },
            {
                name: 'Agency Code',
                selector: row => row.agency_code ?? 'N/A',
                sortable: true,
            },
            // {
            //     name: 'Country',
            //     selector: row => row.country,
            //     sortable: true,
            // },
            // {
            //     name: 'Language',
            //     selector: row => row.lang,
            //     sortable: true,
            // },

            // {
            //     name: 'Is in agency list',
            //     selector: row => row.is_in_agency_list,
            //     sortable: false,
            //     width: "200px",
            // },
            // {
            //     name: 'Action',
            //     cell: row => <ActionCell row={row} queryKey={queryKey} />,
            //     width: "100px",

            // },

        ];
        if (profileData?.can_see_abnormal_use_of_code) {
            temp.push(
                {
                    name: 'Is in agency list',
                    selector: row => row.is_in_agency_list,
                    sortable: false,
                    // width: "200px",
                },)
        }

        if (profileData?.can_remove_abnormal_use_of_code) {
            temp.push(
                {
                    name: 'Action',
                    cell: row => <ActionCell row={row} queryKey={queryKey} />,
                    // width: "100px",

                },)
        }
        return temp;
    })

    //

    return (
        <LoadingErrorContainer isError={isError} isLoading={isPending || profileIsPending} isRefetching={isRefetching}>
            <Group justify='space-between'>
                <Title order={3}>Users</Title>
                <Group>
                    <TextInput type='search' defaultValue={search} onChange={(event) => setSearch(event?.target?.value)} placeholder='Search' leftSection={<IconSearch size={18} />} style={{ alignSelf: "flex-end" }} />

                </Group>

            </Group>
            <DataTable
                columns={columns}
                data={data?.data ?? []}
                progressPending={isPending}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handleChangePerPage}
                onChangePage={handlePageChange}

            // selectableRows

            />
        </LoadingErrorContainer>
    );
};


export default Remote
